require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-analisis-de-las-intervenciones-del-banco-mundial-en.json") })
        }
      }, "path---es-mx-update-analisis-de-las-intervenciones-del-banco-mundial-en");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-analisis-de-las-intervenciones-del-banco-mundial-en!./.cache/json/es-mx-update-analisis-de-las-intervenciones-del-banco-mundial-en.json
// module id = 915
// module chunks = 231608221292675